import { CUSTOMER_LEVEL } from '@wyz/types';
import { CustomerEligibilityWarning } from '~/common/components';
import { usePurchaseContext } from '~/purchase/context';

/**
 * The destocking module is opted into per customer, through the `destockingEnabled` setting of the
 * matched setting template — the tenant-wide DESTOCKING feature flag is only the first gate. This
 * mirrors what the API enforces; it does not replace it.
 */
export default function DestockingCustomerProtected({
  component: Component,
}: {
  component: React.ComponentType;
}) {
  const { state } = usePurchaseContext();
  const targetCustomer = state.targetCustomer;

  if (targetCustomer && targetCustomer.level >= CUSTOMER_LEVEL.N2) {
    return <CustomerEligibilityWarning customer={targetCustomer} />;
  }

  if (targetCustomer?.settingTemplate?.generalSetting.destockingEnabled) {
    return <Component />;
  }

  return <CustomerEligibilityWarning customer={targetCustomer} />;
}
